import type { IConfirmationsProps } from "../../types";
import { Box, Button, Dialog, Typography, DialogTitle, DialogActions } from "@mui/material";

export default function Confirmations(props: IConfirmationsProps) {
  const {
    text,
    disabled,
    selfie,
    isAuthentication,
    isDocumentBack,
    isSelfieApproved,
    document,
    isDocumentApproved,
    documentBack,
    isDocumentBackApproved,
    styles,
    retake,
    proceed,
  } = props;
  return (
    <Dialog
      open={
        (!!selfie && !isSelfieApproved) ||
        (!!document && !isDocumentApproved) ||
        (!!documentBack && !isDocumentBackApproved)
      }
      PaperProps={{ sx: styles.dialogBase }}
    >
      <DialogTitle sx={styles.dialogTitle}>
        <Typography sx={styles.dialogText}>{text.confirmImage}</Typography>
      </DialogTitle>

      <Box
        component="img"
        src={`data:image/jpeg;base64,${
          !isSelfieApproved ? selfie : !isDocumentApproved ? document : !isDocumentBackApproved ? documentBack : ""
        }`}
        alt="image_for_approval"
        sx={styles.approvalImage}
      />

      <DialogActions sx={styles.dialogActions}>
        <Button onClick={proceed} disabled={disabled} variant="contained" sx={styles.continue}>
          {selfie && isAuthentication
            ? text.send
            : document && !isDocumentBack
            ? text.send
            : documentBack
            ? text.send
            : text.continue}
        </Button>

        <Button onClick={retake} disabled={disabled} variant="contained" sx={styles.continue}>
          {text.retake}
        </Button>
        <Typography sx={styles.dialogCaption}>{!isSelfieApproved ? null : text.documentVisible}</Typography>
      </DialogActions>
    </Dialog>
  );
}
